module.exports = __webpack_public_path__ + "static/img/slide-4-image@3x.099dcb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/slide-4-image@3x.jpg
// module id = Q3Ga
// module chunks = 6